// extracted by mini-css-extract-plugin
export default {"container":"ProductPage_container__CDygF","mainContain":"ProductPage_mainContain__fh0hB","bestSellerAllProducts":"ProductPage_bestSellerAllProducts__38yZJ"};